module.exports = __webpack_public_path__ + "img/location_ic.6cf90a3a.png";